export default __webpack_public_path__ + "static/media/2.b6cebee9.svg";